import script from "./InspectionFooterCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./InspectionFooterCard.vue?vue&type=script&lang=ts&setup=true"

import "./InspectionFooterCard.vue?vue&type=style&index=0&id=4c97ba14&lang=less&scoped=true"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c97ba14"]])

export default __exports__